export const SCROLL_TO_QUERY_PARAM = "scrollTo";
